import { createContext } from 'react';
import {DomainList } from "data/domain"

export const DomainContext = createContext(Object.values(DomainList)[0]);